import { OdinController } from '@myosh/odin-components';
import type { Control } from 'react-hook-form';
import type { HierarchyFieldError, HierarchyFieldGroupProps } from './hierarchy-field-group.component';
import { HierarchyFieldGroup } from './hierarchy-field-group.component';

interface HfHierarchyFieldProps extends HierarchyFieldGroupProps {
  control?: Control;
  name?: string;
}

export function HfHierarchyField({
  control,
  name = 'hierarchies',
  value,
  readOnly,
  onChange,
  hierarchySettings,
  hierarchyTypes,
  isUserHierarchy,
  isExternal = false,
  isCompetencyHierarchy,
  ignoreHierarchyAccess,
  usesMultiSelectDropdowns = false,
  showAddNewOption,
}: HfHierarchyFieldProps) {
  return (
    <OdinController
      name={name}
      control={control}
      defaultValue={value}
      onChange={onChange}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <HierarchyFieldGroup
          errorObject={error as unknown as HierarchyFieldError}
          value={value}
          hierarchyTypes={hierarchyTypes}
          readOnly={readOnly}
          onChange={onChange}
          hierarchySettings={hierarchySettings}
          isUserHierarchy={isUserHierarchy}
          isExternal={isExternal}
          isCompetencyHierarchy={isCompetencyHierarchy}
          ignoreHierarchyAccess={ignoreHierarchyAccess}
          control={control}
          usesMultiSelectDropdowns={usesMultiSelectDropdowns}
          showAddNewOption={showAddNewOption}
        />
      )}
    />
  );
}
